module.exports = "hourglass"